/**
 * TripNavIcon — the small shield glyph used in the nav TRIP pill.
 * Reuses the shield silhouette from the report's ScoreShield so the nav
 * mark visually matches the score shield in the report.
 */
export default function TripNavIcon({ size = 16, color = '#1B2B4B' }) {
  return (
    <svg
      width={size}
      height={size * 1.15}
      viewBox="0 0 200 240"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M 100 5 L 185 35 L 185 130 Q 185 175 100 230 Q 15 175 15 130 L 15 35 Z"
        fill={color}
      />
      <text
        x="100" y="150" textAnchor="middle"
        fontFamily="Open Sans, sans-serif" fontSize="70" fontWeight="900" fill="#FFFFFF"
      >★</text>
    </svg>
  );
}
